const listLimits = [
  { value: 50, label: '50' },
  { value: 25, label: '25' },
  { value: 10, label: '10' },
];

export { listLimits };
